export enum TeamsRoutes {
  root = 'teams',
  main = '',
  members = 'members',
}
